import { Component } from '@angular/core';

@Component({
  templateUrl: 'expired.component.html'
})
export class ExpiredComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/agencies/expired.component.ts